import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hooks as virtualCardHooks } from '@ott/shared-virtual-card-logic';
import { showAuth } from 'src/redux/modules/common/authModal/actions';

const VCProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { show } = useSelector((state) => state.common.authModal);
  const { virtualCardFlow: { VirtualCardFlowProvider } } = virtualCardHooks;

  const showModal = useCallback(() => {
    dispatch(showAuth());
  }, []);

  return (
    <VirtualCardFlowProvider auth={{ showModal, visible: show }}>
      {children}
    </VirtualCardFlowProvider>
  );
};

export default VCProvider;
